package one.healthium.bland.presentation.feature.today

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.relocation.BringIntoViewRequester
import androidx.compose.foundation.relocation.bringIntoViewRequester
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.em
import ifaandroid.apps.bland.composeapp.generated.resources.Res
import ifaandroid.apps.bland.composeapp.generated.resources.ic_play_12
import loco.TODAY_LOG_FOOD_BUTTON
import one.healthium.health_advice.ui.message.HealthAdviceMessage
import one.healthium.today.ui.TodayUiState
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.components.AppButtonDefaults
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.Themes
import one.healthium.ui.compose.theme.black
import one.healthium.ui.compose.theme.white
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import androidx.compose.ui.tooling.preview.Preview

@Composable
fun CaloriesTracker(
    state: TodayUiState,
    onAddFoodClicked: () -> Unit,
    onLogSymptomsClicked: () -> Unit,
) {
    val bringIntoViewRequester = remember { BringIntoViewRequester() }

    Column(
        modifier = Modifier
            .bringIntoViewRequester(bringIntoViewRequester)
            .fillMaxWidth()
            .background(AppTheme.colors.primary)
            .statusBarsPadding()
    ) {
        Spacer(Modifier.height(24.dp))
        Row(
            verticalAlignment = Alignment.CenterVertically,
        ) {
            GreetingText(
                modifier = Modifier.weight(1f),
                state = state,
            )
            LogFoodButton(
                modifier = Modifier
                    .alpha(if (state.foodIsEmpty) 0f else 1f)
                    .testTag("log_food_button"),
                onAddFoodClicked = onAddFoodClicked,
            )
        }
        Spacer(Modifier.height(4.dp))
        HealthAdviceMessage(
            bringIntoViewRequester = bringIntoViewRequester,
            onLogSymptomsClicked = onLogSymptomsClicked,
            textAlign = TextAlign.Start,
            style = AppTheme.textStyles.secondary_17_400,
            lineHeight = 1.5.em,
        )
        Spacer(Modifier.height(12.dp))
        CaloriesChart(
            state = state,
            onAddFoodClicked = onAddFoodClicked,
        )
        Spacer(Modifier.height(26.dp))
    }
}

@Composable
private fun GreetingText(
    modifier: Modifier = Modifier,
    state: TodayUiState
) {
    val userName = state.userName
    Text(
        modifier = modifier.padding(start = 24.dp),
        text = if (userName != null) {
            "Hi, $userName" // TODO loco
        } else {
            "Hi!"
        },
        style = AppTheme.textStyles.secondary_36_600,
        color = AppTheme.colors.onPrimary,
    )
}

@Composable
fun LogFoodButton(
    modifier: Modifier = Modifier,
    onAddFoodClicked: () -> Unit,
) {
    AppButton(
        modifier = modifier
            .padding(start = 9.dp, end = 15.dp)
            .height(40.dp),
        onClick = onAddFoodClicked,
        colors = AppButtonDefaults.appButtonColors(
            containerColor = white,
            contentColor = black,
        ),
        contentPadding = PaddingValues(horizontal = 12.dp),
    ) {
        Text(text = stringResource(loco.Res.string.TODAY_LOG_FOOD_BUTTON))
        Spacer(Modifier.width(6.dp))
        Icon(
            painter = painterResource(Res.drawable.ic_play_12),
            contentDescription = null,
        )
    }
}

@Composable
@Preview
private fun CaloriesTrackerPreview() {
    AppTheme(theme = Themes.bland()) {
        CaloriesTracker(
            state = TodayUiState.preview,
            onAddFoodClicked = {},
            onLogSymptomsClicked = {},
        )
    }
}